import AddBottomSpace from './AddBottomSpace'
import { Link, Text } from "@radix-ui/themes";

export default function NavbarBottom() {
  return (
    <>

    <div className="container-fluid">
      <div className="d-flex justify-content-center">
      <div className='row'>
          <div className='col'>
            <Text color size="2" weight="bold">
              <Link href="/impressum">Impressum</Link>
            </Text>
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid">
      <div className="d-flex justify-content-center">

        <div className='row'>
          <div className='col'>
            <Text size="1">
              &copy;
            </Text>
            &nbsp;
            <Text color size="1">
              Interstices
            </Text>
            &nbsp; 
            <Text size="1">
              All rights reserved.
            </Text>

          </div>
        </div>

      </div>
    </div>
    <AddBottomSpace />
    <AddBottomSpace />
    </>
  )
}
